import type { IconData } from '@stacksjs/iconify-core'

export const layoutWindow4Remix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.095 1.546C11.381 1.279 16.586 1 24 1s12.619.279 15.905.546c3.532.287 6.263 3.017 6.55 6.55a155 155 0 0 1 .391 6.899A246 246 0 0 1 47 24c0 7.414-.279 12.619-.545 15.905c-.287 3.532-3.018 6.263-6.55 6.55C36.619 46.722 31.414 47 24 47s-12.619-.278-15.905-.545c-3.532-.287-6.263-3.018-6.55-6.55C1.28 36.619 1 31.414 1 24s.279-12.619.546-15.905c.287-3.532 3.017-6.262 6.55-6.55M18 17h24.908c.057 2.06.092 4.388.092 7c0 7.314-.275 12.41-.532 15.58c-.129 1.58-1.309 2.76-2.887 2.888C36.41 42.725 31.314 43 24 43c-2.198 0-4.195-.025-6-.066zM5.092 17H14v25.804a146 146 0 0 1-5.58-.336c-1.58-.129-2.76-1.309-2.888-2.887C5.275 36.41 5 31.314 5 24c0-2.612.035-4.94.092-7\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default layoutWindow4Remix
